import React from 'react';

import { InputNumber } from '@yuhuinc/ui-library/';

const MoneyInput = ({ handleChange, ...props }) => {
  return (
    <InputNumber
      formatter={value => value && `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      parser={value => value.replace(/\$\s?|(,*)/g, '')}
      precision={2}
      onChange={handleChange}
      {...props}
    />
  );
};

export { MoneyInput };
